<template>
    <div id="app" :class="{ 'blurred': isProcessing }">
        <div class="container mt-2 mb-5">
            <div class="row">
                <div class="col md-12 text-center mt-5 mb-3">
                    <img :src="require('@/assets/logo-nav.webp')" class="img-fluid" width="250" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <h3><span class="material-icons md-24 text-main-gradient">account_circle</span> Configuración
                        Inicial</h3>
                    <div class="welcome-message p-4 mb-4">
                        <h4 class="text-center mb-3">Hola Dr./Dra.</h4>
                        <p class="text-justify">
                            Nos alegra tenerte aquí. Este es tu espacio digital donde podrás gestionar de forma segura,
                            sencilla y profesional todos los aspectos clínicos de tus pacientes.
                            Este sistema ha sido diseñado para médicos independientes como tú, que buscan un aliado
                            digital confiable para modernizar su consultorio y cumplir con la normativa mexicana en
                            salud.
                        </p>
                        <blockquote class="blockquote text-center mt-4">
                            <p class="mb-0">🩺 "Porque cada consulta importa, y cada dato cuenta."</p>
                        </blockquote>
                        <p class="text-center mt-4">
                            <strong class="fw-bold">¡Comienza seleccionando un paquete y organiza tu primer expediente
                                hoy!</strong>
                        </p>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-6" v-for="paquete in paquetes" :key="paquete.id">
                            <div class="card p-4 mb-4  h-100 d-flex flex-column">
                                <h5 class="card-title text-center">{{ paquete.nombre }}</h5>
                                <h2 class="text-center fw-bold">{{ paquete.costo }} mxn/{{ paquete.duracion_dias > 30 ?
                                    'año' : 'mes' }}</h2>
                                <p class="text-left" v-html="paquete.descripcion"></p>
                                <div class="mt-auto text-center">
                                    <vs-button 
                                        :disabled="isProcessing" 
                                        @click="pagarPaquete(paquete)" 
                                        color="rgb(59,222,200)" 
                                        gradient 
                                        block>
                                        Seleccionar 🚀
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    var config = require("@/config/api.json");
    const API = config.api;
    import { loadStripe } from '@stripe/stripe-js';


    export default {
        name: "SeleccionarPaquete",
        data() {
            return {
                currentUser: null,
                paquetes: [], // Lista de paquetes
                isProcessing: false, // Estado para controlar el procesamiento
            };
        },
        async created() {
            const light = localStorage.getItem('light');
            console.log('PRIMER LIGHT', light)

            if (light !== null) {
                // La variable existe en localStorage
                console.log('La variable existe en localStorage');
                document.body.classList.toggle('light-mode', light);
            } else {
                document.body.classList.toggle('light-mode', false);
            }
        },
        mounted() {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (user) {
                    this.currentUser = user;
                }
            } catch (error) {
                console.error('Error loading user from localStorage:', error);
            }
            this.fetchPaquetes();
        },
        methods: {
            async pagarPaquete(paquete) {
                console.log('Paquete seleccionado:', paquete);
                this.isProcessing = true; // Activar el estado de procesamiento
   
                try {
                    const stripe = await loadStripe('pk_live_dew8vb1PPIgiCo7OYa78SdyS');

                    const response = await axios.post(`${API}/crear-sesion`, {
                        nombre: paquete.nombre,
                        costo: paquete.costo,
                        duracion_dias: paquete.duracion_dias,
                        paquete_id: paquete.id,
                        personal_medico_id: this.currentUser.mainId,
                        customer_email: this.currentUser.email,
                    });

                    const sessionId = response.data.id;
                    const result = await stripe.redirectToCheckout({ sessionId });

                    if (result.error) {
                        alert(result.error.message);
                    }
                } catch (error) {
                    console.error('Error al iniciar el pago:', error);
                } finally {
                    this.isProcessing = false; // Desactivar el estado de procesamiento
                }
            },
            async fetchPaquetes() {
                try {
                    const response = await axios.get(`${API}/listar_paquetes`);
                    if (response.data.status === 'success') {
                        this.paquetes = response.data.data;
                    } else {
                        console.error('Error al obtener los paquetes:', response.data.message);
                    }
                } catch (error) {
                    console.error('Error al conectar con el backend:', error);
                }
            },
        },
    };
</script>

<style scoped>
.blurred {
    filter: blur(5px);
    pointer-events: none;
}
.list-unstyled li {
  margin-bottom: 0.5rem; /* Add some spacing between list items */
  display: flex; /* Align icon and text */
  align-items: center;
  justify-content: center; /* Center items */
  text-align: left; /* Align text left within the flex item */
  padding-left: 1rem; /* Add padding for centering effect */
  padding-right: 1rem;
}

.list-unstyled li i {
  margin-right: 0.5rem; /* Space between icon and text */
}
</style>